export const lootboxAwardedLevels = [
    7,
    12,
];